"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  id: "item-1",
  question: "Como o programa de Longevidade Profissional funciona?",
  answer: "Nosso programa é desenhado para líderes experientes que buscam reinventar suas carreiras ou garantir relevância contínua no mercado. Através de mentorias personalizadas e planejamento estratégico, ajudamos a mapear seus próximos passos com segurança e autoridade."
}, {
  id: "item-2",
  question: "Qual é o perfil dos membros da rede de Networking Estratégico?",
  answer: "A rede MASTERPRO+ é composta exclusivamente por executivos C-level, diretores e líderes corporativos com vasta experiência. Mantemos um rigoroso processo de seleção para garantir que as conexões gerem valor real e oportunidades de alto nível."
}, {
  id: "item-3",
  question: "Os programas são individuais ou em grupo?",
  answer: "Oferecemos ambas as modalidades. A Liderança Executiva geralmente envolve sessões individuais para focar em desafios específicos, enquanto nossos fóruns de networking proporcionam ricas interações em pequenos grupos de pares selecionados."
}, {
  id: "item-4",
  question: "Como posso me candidatar para participar?",
  answer: "O primeiro passo é agendar uma sessão de alinhamento estratégico. Durante esta conversa confidencial, avaliaremos seu momento profissional e discutiremos como nossa expertise pode acelerar seus objetivos de longo prazo."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return;
}